import React from 'react';
import { FaQuoteLeft } from 'react-icons/fa';
import { Testimonial } from '../../data/testimonials';

interface TestimonialCardProps {
  testimonial: Testimonial;
}

/**
 * Componente de card individual para cada depoimento
 * Chamado por: TestimonialsCarousel
 * Chama: nenhum componente
 * Complexidade: O(m) onde m é o tamanho do texto para destacar palavras-chave
 */
const TestimonialCard: React.FC<TestimonialCardProps> = ({ testimonial }) => {
  
  /**
   * Destaca palavras-chave no texto do depoimento
   * Complexidade: O(m) onde m é o tamanho do texto
   */
  const highlightKeywords = (text: string) => {
    const keywords = [
      'economia imediata sem instalação',
      'sem burocracias', 
      'bem abaixo do comum',
      'ótimos resultados',
      'reduzindo o custo',
      'fatura de energia'
    ];
    
    let highlightedText = text;
    
    keywords.forEach(keyword => {
      const regex = new RegExp(`(${keyword})`, 'gi');
      highlightedText = highlightedText.replace(
        regex, 
        '<span class="font-semibold" style="color: #1e40af;">$1</span>'
      );
    });
    
    return highlightedText;
  };

  return (
    <div className="flex flex-col lg:flex-row h-full">
      {/* Imagem */}
      <div className="lg:w-1/2 relative h-80 lg:h-full">
        <img 
          src={testimonial.image}
          alt={testimonial.imageAlt}
          className="w-full h-full object-cover"
        />
        {/* Badge sobreposto na imagem */}
        <div className="absolute bottom-6 left-6">
          <span className="inline-block bg-secondary text-primary text-sm font-bold px-4 py-2 rounded-full shadow-lg">
            {testimonial.badge}
          </span>
        </div>
      </div>
      
      {/* Conteúdo */}
      <div className="lg:w-1/2 h-full flex flex-col bg-gradient-to-br from-white to-gray-50">
        <div className="p-8 lg:p-16 flex flex-col justify-between h-full">
          
          {/* Ícone de aspas grande */}
          <div className="mb-4">
            <FaQuoteLeft className="text-4xl lg:text-6xl text-secondary opacity-80" />
          </div>
          
          {/* Citação - área flexível */}
          <div className="flex-1 flex items-start py-4 min-h-0">
            <p 
              className="text-gray-700 text-base lg:text-lg leading-relaxed font-medium"
              style={{ fontFamily: 'Poppins, sans-serif' }}
              dangerouslySetInnerHTML={{ 
                __html: highlightKeywords(testimonial.quote) 
              }}
            />
          </div>
          
          {/* Autor - fixo na parte inferior */}
          <div className="mt-4">
            <h3 className="text-primary text-xl lg:text-2xl font-bold mb-1" style={{ fontFamily: 'Poppins, sans-serif' }}>
              {testimonial.author}
            </h3>
            <p className="text-gray-600 text-base lg:text-lg font-medium" style={{ fontFamily: 'Poppins, sans-serif' }}>
              {testimonial.company}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialCard; 